import React from 'react';

import { Link } from 'react-router-dom';
import { Layout } from 'components/organisms/layout';
/** styles **/
import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';
import { PossibleItems, OurFutures, Concept, PhotoGallery } from 'components/organisms';
import s from '../styles/pages/about.module.scss';

export const About: React.FC = () => {
  return (
    <Layout>
      <div className={s.aboutPageWrapper}>
        <h2 className={s.pageTitle}>
          真の<br className={s.spOnly} />“ペットと人の共生”<br className={s.spOnly} />マンションとは
        </h2>
        <div className={s.aboutContent}>
          <div id="items">
            <PossibleItems />
          </div>
          <div id="features">
            <OurFutures />
          </div>
          <div id="concept">
            <Concept />
          </div>
          <PhotoGallery />
        </div>

        <Link className={s.topLink} to="/">
          <BlackCircleArrow className={s.navButton} />トップページへ戻る
        </Link>
      </div>
    </Layout>
  );
};
